@let taskCount = tasksCount$ | async;

<mat-toolbar
  class="mat-toolbar--small"
  [class.mat-toolbar--border]="toolbarConfig?.showBorder">
  <button
    mat-icon-button
    *ngIf="!mini && !toolbarConfig?.showBack && !isLargeScreen"
    (click)="toggleToolbar.emit()">
    <mat-icon>menu</mat-icon>
  </button>
  <a
    mat-icon-button
    *ngIf="toolbarConfig?.showBack"
    [routerLink]="toolbarConfig?.url"
    [matTooltip]="'CMD_GO_BACK' | translate"
    matTooltipPosition="right">
    <mat-icon>arrow_back</mat-icon>
  </a>
  <div
    fxFlex
    fxLayout="row"
    fxLayoutAlign="end center"
    class="toolbar-content-wrapper">
    <ng-template [ngTemplateOutlet]="toolbarConfig?.template"></ng-template>

    <div class="toolbar-action-group">
      <div class="toolbar-action-group__list">
        <button
          mat-button
          type="button"
          class="toolbar-action-btn qt-accent-toolbar-button toolbar-action--add-deal"
          (click)="addDeal.emit()"
          matTooltip="{{ 'GNR_ADD_DEAL' | translate }}"
          matTooltipPosition="below">
          <mat-icon>add</mat-icon>
          Add deal
        </button>
        <button
          *ngIf="showAiChat"
          mat-stroked-button
          type="button"
          class="toolbar-action toolbar-action--allo"
          [attr.aria-label]="'GNR_AI_ALLO' | translate"
          (click)="openAiChat.emit()"
          [class.toolbar-action--active]="
            rightPanelOpened && rightPanelActiveTab === 'chat'
          "
          matTooltip="{{ 'GNR_AI_ALLO' | translate }}"
          matTooltipPosition="below">
          <img
            class="toolbar-action__icon toolbar-action__icon--allo"
            src="assets/img/allo-ai-logo.svg"
            alt=""
            width="24"
            height="24"
            aria-hidden="true"
            focusable="false" />
        </button>
        <button
          mat-stroked-button
          type="button"
          class="toolbar-action"
          [attr.aria-label]="'GNR_MY_TASKS' | translate"
          (click)="openTasks.emit()"
          [class.toolbar-action--active]="
            rightPanelOpened && rightPanelActiveTab === 'tasks'
          "
          [matBadge]="taskCount"
          [matBadgeHidden]="!taskCount"
          matBadgeColor="accent"
          matBadgeSize="small"
          matTooltip="{{ 'GNR_MY_TASKS' | translate }}"
          matTooltipPosition="below">
          <svg
            class="toolbar-action__icon"
            viewBox="0 0 35 35"
            aria-hidden="true"
            focusable="false">
            <path
              d="M14.5833 26.25V23.3333H23.3333V26.25H14.5833ZM8.82292 26.25L0.546875 17.974L2.625 15.8958L8.82292 22.0938L22.1667 8.75L24.2448 10.8281L8.82292 26.25ZM20.4167 20.4167V17.5H29.1667V20.4167H20.4167ZM26.25 14.5833V11.6667H35V14.5833H26.25Z" />
          </svg>
        </button>
        <button
          mat-stroked-button
          type="button"
          class="toolbar-action"
          [attr.aria-label]="'CMD_CREATE_CONTACT' | translate"
          (click)="addContact.emit()"
          matTooltip="{{ 'CMD_CREATE_CONTACT' | translate }}"
          matTooltipPosition="below">
          <svg
            class="toolbar-action__icon"
            viewBox="0 0 30 30"
            aria-hidden="true"
            focusable="false">
            <path
              d="M1.25 25V21.5C1.25 20.7917 1.43229 20.1406 1.79688 19.5469C2.16146 18.9531 2.64583 18.5 3.25 18.1875C4.54167 17.5417 5.85417 17.0573 7.1875 16.7344C8.52083 16.4115 9.875 16.25 11.25 16.25C12.625 16.25 13.9792 16.4115 15.3125 16.7344C16.6458 17.0573 17.9583 17.5417 19.25 18.1875C19.8542 18.5 20.3385 18.9531 20.7031 19.5469C21.0677 20.1406 21.25 20.7917 21.25 21.5V25H1.25ZM23.75 25V21.25C23.75 20.3333 23.4948 19.4531 22.9844 18.6094C22.474 17.7656 21.75 17.0417 20.8125 16.4375C21.875 16.5625 22.875 16.776 23.8125 17.0781C24.75 17.3802 25.625 17.75 26.4375 18.1875C27.1875 18.6042 27.7604 19.0677 28.1562 19.5781C28.5521 20.0885 28.75 20.6458 28.75 21.25V25H23.75ZM11.25 15C9.875 15 8.69792 14.5104 7.71875 13.5312C6.73958 12.5521 6.25 11.375 6.25 10C6.25 8.625 6.73958 7.44792 7.71875 6.46875C8.69792 5.48958 9.875 5 11.25 5C12.625 5 13.8021 5.48958 14.7812 6.46875C15.7604 7.44792 16.25 8.625 16.25 10C16.25 11.375 15.7604 12.5521 14.7812 13.5312C13.8021 14.5104 12.625 15 11.25 15ZM23.75 10C23.75 11.375 23.2604 12.5521 22.2812 13.5312C21.3021 14.5104 20.125 15 18.75 15C18.5208 15 18.2292 14.974 17.875 14.9219C17.5208 14.8698 17.2292 14.8125 17 14.75C17.5625 14.0833 17.9948 13.3438 18.2969 12.5312C18.599 11.7188 18.75 10.875 18.75 10C18.75 9.125 18.599 8.28125 18.2969 7.46875C17.9948 6.65625 17.5625 5.91667 17 5.25C17.2917 5.14583 17.5833 5.07812 17.875 5.04688C18.1667 5.01562 18.4583 5 18.75 5C20.125 5 21.3021 5.48958 22.2812 6.46875C23.2604 7.44792 23.75 8.625 23.75 10ZM3.75 22.5H18.75V21.5C18.75 21.2708 18.6927 21.0625 18.5781 20.875C18.4635 20.6875 18.3125 20.5417 18.125 20.4375C17 19.875 15.8646 19.4531 14.7188 19.1719C13.5729 18.8906 12.4167 18.75 11.25 18.75C10.0833 18.75 8.92708 18.8906 7.78125 19.1719C6.63542 19.4531 5.5 19.875 4.375 20.4375C4.1875 20.5417 4.03646 20.6875 3.92188 20.875C3.80729 21.0625 3.75 21.2708 3.75 21.5V22.5ZM11.25 12.5C11.9375 12.5 12.526 12.2552 13.0156 11.7656C13.5052 11.276 13.75 10.6875 13.75 10C13.75 9.3125 13.5052 8.72396 13.0156 8.23438C12.526 7.74479 11.9375 7.5 11.25 7.5C10.5625 7.5 9.97396 7.74479 9.48438 8.23438C8.99479 8.72396 8.75 9.3125 8.75 10C8.75 10.6875 8.99479 11.276 9.48438 11.7656C9.97396 12.2552 10.5625 12.5 11.25 12.5Z" />
          </svg>
        </button>
        <button
          mat-stroked-button
          type="button"
          class="toolbar-action"
          [attr.aria-label]="'GNR_ADD_NOTE' | translate"
          (click)="addNote.emit()"
          matTooltip="{{ 'GNR_ADD_NOTE' | translate }}"
          matTooltipPosition="below">
          <svg
            class="toolbar-action__icon"
            viewBox="0 0 35 35"
            aria-hidden="true"
            focusable="false">
            <path
              d="M7.29167 30.6252C6.48958 30.6252 5.80295 30.3396 5.23177 29.7684C4.66059 29.1972 4.375 28.5106 4.375 27.7085V7.29183C4.375 6.48975 4.66059 5.80311 5.23177 5.23193C5.80295 4.66075 6.48958 4.37516 7.29167 4.37516H13.4167C13.7326 3.50016 14.2613 2.7953 15.0026 2.26058C15.7439 1.72586 16.5764 1.4585 17.5 1.4585C18.4236 1.4585 19.2561 1.72586 19.9974 2.26058C20.7387 2.7953 21.2674 3.50016 21.5833 4.37516H27.7083C28.5104 4.37516 29.197 4.66075 29.7682 5.23193C30.3394 5.80311 30.625 6.48975 30.625 7.29183V27.7085C30.625 28.5106 30.3394 29.1972 29.7682 29.7684C29.197 30.3396 28.5104 30.6252 27.7083 30.6252H7.29167ZM7.29167 27.7085H27.7083V7.29183H7.29167V27.7085ZM10.2083 24.7918H20.4167V21.8752H10.2083V24.7918ZM10.2083 18.9585H24.7917V16.0418H10.2083V18.9585ZM10.2083 13.1252H24.7917V10.2085H10.2083V13.1252ZM17.5 6.19808C17.816 6.19808 18.0773 6.09478 18.2839 5.88818C18.4905 5.68159 18.5937 5.4203 18.5937 5.10433C18.5937 4.78836 18.4905 4.52707 18.2839 4.32048C18.0773 4.11388 17.816 4.01058 17.5 4.01058C17.184 4.01058 16.9227 4.11388 16.7161 4.32048C16.5095 4.52707 16.4062 4.78836 16.4062 5.10433C16.4062 5.4203 16.5095 5.68159 16.7161 5.88818C16.9227 6.09478 17.184 6.19808 17.5 6.19808Z" />
          </svg>
        </button>
        <qt-avatar-menu
          *ngIf="media.isActive('gt-xs')"
          class="toolbar-action-group__avatar"
          isHiddenUserName="true"></qt-avatar-menu>
      </div>
    </div>
  </div>
</mat-toolbar>
